import { render, staticRenderFns } from "./reportEditor.vue?vue&type=template&id=3bd980b2&scoped=true&"
import script from "./reportEditor.vue?vue&type=script&lang=ts&"
export * from "./reportEditor.vue?vue&type=script&lang=ts&"
import style0 from "./reportEditor.vue?vue&type=style&index=0&id=3bd980b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd980b2",
  null
  
)

export default component.exports